import { Link } from "react-router-dom";
import { IMAGES, CONTACT } from "../../data";
import { Home, Phone } from "lucide-react";

export const NotFound = () => (
  <div className="min-h-screen bg-oyf-charcoal text-white flex flex-col items-center justify-center px-6 text-center" data-testid="not-found">
    <img src={IMAGES.logo} alt="One York Freight" className="h-10 bg-white rounded p-1.5 mb-10" />
    <p className="font-display font-extrabold text-oyf-yellow text-7xl md:text-9xl leading-none">404</p>
    <h1 className="font-display font-extrabold text-2xl md:text-4xl mt-4">This route wasn&apos;t found</h1>
    <p className="text-white/60 mt-3 max-w-md">The page you&apos;re looking for may have been moved or no longer exists. Let&apos;s get you back on route.</p>
    <div className="mt-8 flex flex-col sm:flex-row gap-3">
      <Link to="/" className="inline-flex items-center justify-center gap-2 bg-oyf-yellow text-oyf-black font-bold px-6 py-3.5 rounded-md hover:-translate-y-0.5 transition-transform"><Home size={18} /> Back to Home</Link>
      <a href={CONTACT.tel} className="inline-flex items-center justify-center gap-2 border-2 border-white/30 font-bold px-6 py-3.5 rounded-md hover:border-oyf-yellow hover:text-oyf-yellow transition-colors"><Phone size={17} /> Call {CONTACT.phone}</a>
    </div>
  </div>
);
